/**
 * Word counting for the fields whose limit is expressed in words.
 *
 * IMPORTANT: this is a byte-for-byte copy of `countWords` in
 * `api/src/domain/text.ts`. The two must agree, or this page will show 1,999
 * words while the API rejects the save. There is no shared package between the
 * API and the web app to put it in, and duplicating eight lines is a smaller
 * problem than inventing one.
 */

/** A treatment description, in words. The studio's stated limit. */
export const DESCRIPTION_MAX_WORDS = 2000;

/** Hard character ceiling, so an arbitrarily long "word" cannot be unbounded. */
export const DESCRIPTION_MAX_CHARS = DESCRIPTION_MAX_WORDS * 12;

/**
 * Words separated by any run of whitespace.
 *
 * Deliberately simple: a hyphenated phrase counts as one word and a line break
 * counts as a separator, which is how a person counts when they look at a
 * paragraph.
 */
export function countWords(text: string): number {
  const trimmed = text.trim();
  if (trimmed.length === 0) return 0;
  return trimmed.split(/\s+/).length;
}
